import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-amber-50 text-xs text-gray-800 w-full">
      <div className="max-w-4xl p-2 ps-5 flex items-center mx-auto">
        <div className="flex flex-col flex-1">
          <div className="mt-1">
            <Link to={"/contact"}>{t("contactUs")}</Link>
          </div>
          <div className="mt-1">
            <Link to={"/terms-and-condition"}>Terms and Conditions</Link>
          </div>
          <div className="mt-1">
            <Link to={"/privacy"}>Privacy Policy</Link>
          </div>
          <div className="mt-1">
            <Link to={"/refund-and-cancellation"}>
              Refund and Cancellations
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-center ml-4">
          <img
            src="/images/karkhana_logo.png"
            alt="Karkhana Logo"
            className="h-16 w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactFooter;
